import type { User } from '@/types/domains/UserType';
import { isSpecialRank } from '@/utils/UserHelper';

const STORAGE_KEY = 'daily_popup_last_shown_at';

export const useDailyPopup = () => {
  const dailyPopupVisible = useState('dailyPopupVisible', () => false);

  const checkDailyPopup = (user: User | null) => {
    if (!user) return;
    // ゴールド・プラチナ会員。ログイン直後に `/special-message` へ飛ばされて買い物ができないので、
    // キャンペーンの導線を出さない。**出すと遷移までの一瞬だけポップが見える**（#1384）
    if (isSpecialRank(user)) return;
    // 購入済ランク以外かつキャンペーンが無い場合
    if (!user.hasCampaign) return;
    // キャンペーン商品を購入していた場合（2026/05考慮しないよう変更）
    // if (user.isPurchasedCampaign) return;

    const today = new Date().toISOString().split('T')[0];
    const lastShown = localStorage.getItem(STORAGE_KEY);

    if (lastShown !== today) {
      dailyPopupVisible.value = true;
      localStorage.setItem(STORAGE_KEY, today);
    }
  };

  const closeDailyPopup = () => {
    dailyPopupVisible.value = false;
  };

  return { dailyPopupVisible, checkDailyPopup, closeDailyPopup };
};
